// The config module, not the package index, so this file never reaches Vue and
// every lane shares the one registry.
import setConfigs from '@gitlab/duo-ui/dist/config';
import { __, s__ } from '~/locale';

setConfigs({
  translations: {
    'AgenticBinaryFeedback.accurateInfo': s__('DuoChat|Accurate information'),
    'AgenticBinaryFeedback.back': __('Back'),
    'AgenticBinaryFeedback.close': __('Close'),
    'AgenticBinaryFeedback.goodExamples': s__('DuoChat|Good examples'),
    'AgenticBinaryFeedback.missingSteps': s__('DuoChat|Missing steps'),
    'AgenticBinaryFeedback.outdatedIncorrect': s__('DuoChat|Outdated/incorrect'),
    'AgenticBinaryFeedback.placeholder': s__('DuoChat|Share your feedback...'),
    'AgenticBinaryFeedback.savedTime': s__('DuoChat|Saved me time'),
    'AgenticBinaryFeedback.solvedProblem': s__('DuoChat|Solved my problem'),
    'AgenticBinaryFeedback.submit': __('Submit'),
    'AgenticBinaryFeedback.tellUsMore': s__('DuoChat|Tell us more'),
    'AgenticBinaryFeedback.thanks': s__('DuoChat|Thanks for the feedback!'),
    'AgenticBinaryFeedback.thumbsDown': s__('DuoChat|Not helpful'),
    'AgenticBinaryFeedback.thumbsDownHeader': s__('DuoChat|What would have been more helpful?'),
    'AgenticBinaryFeedback.thumbsUp': s__('DuoChat|Helpful'),
    'AgenticBinaryFeedback.thumbsUpHeader': s__('DuoChat|What made this helpful?'),
    'AgenticBinaryFeedback.tooGeneric': s__('DuoChat|Too generic'),
    'AgenticBinaryFeedback.wrongContext': s__('DuoChat|Wrong context'),
    'AgenticDuoChat.chatCancelLabel': __('Cancel'),
    'AgenticDuoChat.chatDefaultPredefinedPromptsChangePassword': s__(
      'DuoChat|How do I change my password in GitLab?',
    ),
    'AgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': s__(
      'DuoChat|How do I clone a repository?',
    ),
    'AgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': s__(
      'DuoChat|How do I create a template?',
    ),
    'AgenticDuoChat.chatDefaultPredefinedPromptsForkProject': s__(
      'DuoChat|How do I fork a project?',
    ),
    'AgenticDuoChat.chatDefaultTitle': s__('GitLabDuo|GitLab Duo Agentic Chat'),
    'AgenticDuoChat.chatDisclaimer': s__(
      'DuoChat|Chat can autonomously change code. Responses and changes can be inaccurate. Review carefully.',
    ),
    'AgenticDuoChat.chatEmptyStateTitle': s__(
      'DuoChat|👋 I am GitLab Duo Agentic Chat, your personal AI-powered assistant. How can I help you today?',
    ),
    'AgenticDuoChat.chatHistoryTitle': s__('DuoChat|Chat history'),
    'AgenticDuoChat.chatPromptPlaceholderDefault': s__('GitLabDuo|GitLab Duo Agentic Chat'),
    'AgenticDuoChat.chatPromptPlaceholderWithCommands': s__('DuoChat|Type /help to learn more'),
    'AgenticDuoChat.chatSubmitLabel': s__('DuoChat|Send chat message.'),
    'AgenticToolApprovalFlow.defaultDescription': s__(
      'DuoChat|GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
    ),
    'AgenticToolApprovalModal.approveAllText': s__('DuoChat|Always approve this tool'),
    'AgenticToolApprovalModal.approveOnceText': s__('DuoChat|Approve Once'),
    'AgenticToolApprovalModal.approveText': __('Approve'),
    'AgenticToolApprovalModal.defaultDescription': s__(
      'DuoChat|GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
    ),
    'AgenticToolApprovalModal.denyText': __('Deny'),
    'AgenticToolApprovalModal.title': s__('DuoChat|Tool Approval Required'),
    'AgenticToolApprovalModal.toolLabel': s__('DuoChat|Tool:'),
    'AgenticToolApprovalModal.toolUnknown': __('Unknown'),
    'AgenticToolRejectionModal.backText': __('Back'),
    'AgenticToolRejectionModal.description': s__(
      'DuoChat|You are about to reject the tool execution. Would you like to provide a reason?',
    ),
    'AgenticToolRejectionModal.label': s__('DuoChat|Rejection reason'),
    'AgenticToolRejectionModal.placeholder': s__(
      "DuoChat|Explain why you're rejecting this tool execution...",
    ),
    'AgenticToolRejectionModal.submitText': s__('DuoChat|Submit Rejection'),
    'AgenticToolRejectionModal.title': s__('DuoChat|Provide Rejection Reason'),
    'BaseToolParams.ExpandDescriptionTitle': s__('DuoChat|Read description'),
    'BaseToolParams.ExpandJsonViewTitle': s__('DuoChat|See request parameters as JSON'),
    'BaseToolParams.confidentialLabel': __('Confidential'),
    'BaseToolParams.dismissalReasonLabel': s__('DuoChat|Dismissal reason'),
    'BaseToolParams.dueDateLabel': __('Due date'),
    'BaseToolParams.epicLabel': __('Epic'),
    'BaseToolParams.groupLabel': __('Group'),
    'BaseToolParams.healthStatusLabel': __('Health status'),
    'BaseToolParams.issueLabel': __('Issue'),
    'BaseToolParams.labelsLabel': __('Labels'),
    'BaseToolParams.mergeRequestLabel': __('Merge request'),
    'BaseToolParams.projectLabel': __('Project'),
    'BaseToolParams.sourceBranchLabel': __('Source branch'),
    'BaseToolParams.startDateLabel': __('Start date'),
    'BaseToolParams.stateLabel': __('State'),
    'BaseToolParams.targetBranchLabel': __('Target branch'),
    'BaseToolParams.typeLabel': __('Type'),
    'BaseToolParams.vulnerabilityLabel': __('Vulnerability'),
    'BaseToolParams.workItemLabel': __('Work item'),
    'CreateCommitToolParams.actionWithNoContent': s__(
      'DuoChat|This action does not have any content.',
    ),
    'CreateCommitToolParams.chmodFileActionLabel': s__(
      'DuoChat|Change permissions for file %{filePath}',
    ),
    'CreateCommitToolParams.commitSummaryAutoBranchMessage': s__(
      'DuoChat|Commit and push to a new branch in repository %{repository}.',
    ),
    'CreateCommitToolParams.commitSummaryAutoBranchMessageNoRepo': s__(
      'DuoChat|Commit and push to a new branch.',
    ),
    'CreateCommitToolParams.commitSummaryMessage': s__(
      'DuoChat|Commit and push to branch %{branch} in repository %{repository}.',
    ),
    'CreateCommitToolParams.commitSummaryMessageNoRepo': s__(
      'DuoChat|Commit and push to branch %{branch}.',
    ),
    'CreateCommitToolParams.createFileActionLabel': s__('DuoChat|Create file %{filePath}'),
    'CreateCommitToolParams.deleteFileActionLabel': s__('DuoChat|Delete file %{filePath}'),
    'CreateCommitToolParams.expandFileChanges': s__('DuoChat|Expand file changes'),
    'CreateCommitToolParams.moveFileActionLabel': s__('DuoChat|Move file %{filePath}'),
    'CreateCommitToolParams.noActionsMessage': s__('DuoChat|The commit does not contain changes.'),
    'CreateCommitToolParams.readCommitMessage': s__('DuoChat|Read commit message'),
    'CreateCommitToolParams.unknownFileActionLabel': s__('DuoChat|Modify file %{filePath}'),
    'CreateCommitToolParams.updateFileActionLabel': s__('DuoChat|Update file %{filePath}'),
    'DuoChat.chatBackLabel': s__('DuoChat|Back to history'),
    'DuoChat.chatBackToChatToolTip': s__('DuoChat|Back to chat'),
    'DuoChat.chatCancelLabel': __('Cancel'),
    'DuoChat.chatDefaultPredefinedPromptsChangePassword': s__(
      'DuoChat|How do I change my password in GitLab?',
    ),
    'DuoChat.chatDefaultPredefinedPromptsCloneRepository': s__(
      'DuoChat|How do I clone a repository?',
    ),
    'DuoChat.chatDefaultPredefinedPromptsCreateTemplate': s__(
      'DuoChat|How do I create a template?',
    ),
    'DuoChat.chatDefaultPredefinedPromptsForkProject': s__('DuoChat|How do I fork a project?'),
    'DuoChat.chatDefaultTitle': s__('DuoChat|GitLab Duo Chat'),
    'DuoChat.chatDropdownMoreOptions': s__('DuoChat|More options'),
    'DuoChat.chatEmptyStateTitle': s__(
      'DuoChat|👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
    ),
    'DuoChat.chatHistoryInfo': s__('DuoChat|Inactive chats are deleted after 30 days.'),
    'DuoChat.chatHistorySearch': s__('DuoChat|Search chat history'),
    'DuoChat.chatHistoryToolTip': s__('DuoChat|Chat history'),
    'DuoChat.chatNewLabel': s__('DuoChat|New chat'),
    'DuoChat.chatNewToolTip': s__('DuoChat|New chat'),
    'DuoChat.chatPromptPlaceholderDefault': s__('DuoChat|GitLab Duo Chat'),
    'DuoChat.chatPromptPlaceholderWithCommands': s__('DuoChat|Type /help to learn more'),
    'DuoChat.chatSubmitLabel': s__('DuoChat|Send chat message.'),
    'DuoChat.chatTitle': s__('DuoChat|GitLab Duo Chat'),
    'DuoChat.closeChatHeaderLabel': s__('DuoChat|Close chat'),
    'DuoChat.copySessionIdFailedToast': s__('DuoChat|Could not copy session ID'),
    'DuoChat.copySessionIdSuccessToast': s__('DuoChat|Session ID copied to clipboard'),
    'DuoChat.copySessionIdTooltip': s__('DuoChat|Copy session ID: %{id}'),
    'DuoChat.emptyHistoryAlt': s__(
      'DuoChat|Clock icon with circular arrow, indicating chat history or time-based functionality',
    ),
    'DuoChat.emptyHistoryCopy': s__('DuoChat|Your previous chats will appear here.'),
    'DuoChat.emptyHistoryTitle': s__('DuoChat|See your chat history'),
    'DuoChat.loadingThreads': s__('DuoChat|Loading chat history...'),
    'DuoChat.noSearchResults': s__('DuoChat|No results found'),
    'DuoChat.openChatLabel': s__('DuoChat|Open chat: %{title}'),
    'DuoChat.searchPlaceholder': s__('DuoChat|Search chats...'),
    'DuoChat.threadDeleteLabel': s__('DuoChat|Delete this chat'),
    'DuoChat.untitledChatTitle': s__('DuoChat|Untitled Chat'),
    'DuoChat.verifiedAgent': s__('DuoChat|Created and maintained by GitLab'),
    'DuoChatContextItemDetailsModal.contentErrorMessage': s__(
      'DuoChat|Item content could not be displayed.',
    ),
    'DuoChatContextItemDetailsModal.title': __('Preview'),
    'DuoChatContextItemMenu.emptyStateMessage': s__('DuoChat|No results found'),
    'DuoChatContextItemMenu.loadingMessage': __('Loading…'),
    'DuoChatContextItemMenu.searchInputPlaceholder': s__('DuoChat|Search %{categoryLabel}…'),
    'DuoChatContextItemMenu.selectedContextItemsTitle': s__('DuoChat|Included references'),
    'DuoChatContextItemPopover.DisabledReason': __('This item is disabled'),
    'DuoChatConversation.newChat': s__('DuoChat|New chat'),
    'DuoChatLoader.gitlabDuo': s__('GitLabDuo|GitLab Duo'),
    'DuoChatLoader.loaderLoadingMessage': s__('DuoChat|%{tool} is %{transition} an answer'),
    'DuoChatLoader.loaderLoadingTransitionsFinding': s__('DuoChat|finding'),
    'DuoChatLoader.loaderLoadingTransitionsGenerating': s__('DuoChat|generating'),
    'DuoChatLoader.loaderLoadingTransitionsProducing': s__('DuoChat|producing'),
    'DuoChatLoader.loaderLoadingTransitionsWorkingOn': s__('DuoChat|working on'),
    'DuoChatMessage.branchLabel': __('Branch'),
    'DuoChatMessage.chatMessageCopied': __('Copied'),
    'DuoChatMessage.chatMessageCopyToClipboard': __('Copy to clipboard'),
    'DuoChatMessage.collapseDetails': s__('DuoChat|Collapse details'),
    'DuoChatMessage.expandDetails': s__('DuoChat|Expand details'),
    'DuoChatMessage.fromDuo': s__('DuoChat|Duo:'),
    'DuoChatMessage.fromMe': s__('DuoChat|Me:'),
    'DuoChatMessage.modalAlertText': s__(
      'DuoChat|GitLab team members cannot view your conversation. Please be as descriptive as possible.',
    ),
    'DuoChatMessage.modalBetterResponse': s__(
      'DuoChat|How the response might better meet your needs.',
    ),
    'DuoChatMessage.modalDidWhat': s__('DuoChat|What were you doing?'),
    'DuoChatMessage.modalImproveWhat': s__('DuoChat|How could the response be improved?'),
    'DuoChatMessage.modalInteraction': s__(
      'DuoChat|The situation in which you interacted with GitLab Duo Chat.',
    ),
    'DuoChatMessage.modalMessageError': s__('DuoChat|Error sending the message'),
    'DuoChatMessage.modalTitle': s__('DuoChat|Give feedback on GitLab Duo Chat'),
    'DuoChatMessage.projectLabel': __('Project'),
    'DuoChatMessage.startBranchLabel': s__('DuoChat|Start branch'),
    'DuoRecentCollapsable.viewAllText': __('View All'),
    'GlDuoChat.chatDisclaimer': s__('DuoChat|Responses may be inaccurate. Verify before use.'),
    'GlDuoChat.chatHistoryTitle': s__('DuoChat|Chat history'),
    'IssuableToolParams.NOTE_ACCORDION_TITLE': s__("DuoChat|Read note's content"),
    // Not externalized: contains raw HTML (<em>) expected by the duo-ui component
    'IssuableToolParams.TITLE_MESSAGE': 'Set the title "<em>%{title}</em>".',
    'MessageToolApproval.approveAllText': s__('DuoChat|Always approve this tool'),
    'MessageToolApproval.approveSessionText': s__('DuoChat|Approve for session'),
    'MessageToolApproval.approveText': __('Approve'),
    'MessageToolApproval.approvingText': s__('DuoChat|Approving...'),
    'MessageToolApproval.cancelText': __('Cancel'),
    'MessageToolApproval.collapseButtonCollapsed': s__('DuoChat|Display tool details'),
    'MessageToolApproval.collapseButtonExpanded': s__('DuoChat|Hide tool details'),
    'MessageToolApproval.createCommitTitle': s__('DuoChat|Commit and push to repository'),
    'MessageToolApproval.denialReasonLabel': s__('DuoChat|Rejection reason'),
    'MessageToolApproval.denialReasonPlaceholder': s__(
      "DuoChat|Tell Duo why you're rejecting this tool execution...",
    ),
    'MessageToolApproval.denyText': __('Deny'),
    'MessageToolApproval.denyingText': s__('DuoChat|Denying...'),
    'MessageToolApproval.multiToolTitle': s__('DuoChat|Duo wants to execute %{count} tools.'),
    'MessageToolApproval.noParametersText': s__(
      'DuoChat|No parameters will be sent with this request.',
    ),
    'MessageToolApproval.parametersText': s__('DuoChat|Request parameters'),
    'MessageToolApproval.toolApprovalDescription': s__(
      'DuoChat|GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
    ),
    'MessageToolApproval.toolLabel': s__('DuoChat|Tool:'),
    'MessageToolApproval.toolStatusApproved': s__('DuoChat|Approved'),
    'MessageToolApproval.toolStatusPending': s__('DuoChat|Pending'),
    'MessageToolApproval.toolUnknown': __('Unknown'),
    No: __('No'),
    'PreBlock.COPY_TO_CLIPBOARD_TEXT': __('Copy to clipboard'),
    'RunCommandToolParams.ACCORDION_TITLE': s__('DuoChat|Expand command output'),
    'WebAgenticDuoChat.agenticChatEmptyStateGreeting': s__('DuoChat|Hello, I\u2019m %{agentName}!'),
    'WebAgenticDuoChat.chatCancelLabel': __('Cancel'),
    'WebAgenticDuoChat.chatDefaultPredefinedPromptsChangePassword': s__(
      'DuoChat|How do I change my password in GitLab?',
    ),
    'WebAgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': s__(
      'DuoChat|How do I clone a repository?',
    ),
    'WebAgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': s__(
      'DuoChat|How do I create a template?',
    ),
    'WebAgenticDuoChat.chatDefaultPredefinedPromptsForkProject': s__(
      'DuoChat|How do I fork a project?',
    ),
    'WebAgenticDuoChat.chatDefaultTitle': s__('GitLabDuo|GitLab Duo Agentic Chat'),
    'WebAgenticDuoChat.chatDisclaimer': s__(
      'DuoChat|Responses may be inaccurate. Verify before use.',
    ),
    'WebAgenticDuoChat.chatEmptyStateDescription': s__('DuoChat|How can I help you today?'),
    'WebAgenticDuoChat.chatEmptyStateTitle': s__(
      'DuoChat|I am GitLab Duo Agentic Chat, your personal AI-powered assistant.',
    ),
    'WebAgenticDuoChat.chatHistoryTitle': s__('DuoChat|Chat history'),
    'WebAgenticDuoChat.chatModelPlaceholder': s__('GitLabDuo|GitLab Duo Agentic Chat'),
    'WebAgenticDuoChat.chatPromptPlaceholderDefault': s__(
      "DuoChat|Let's work through this together...",
    ),
    'WebAgenticDuoChat.chatPromptPlaceholderWithCommands': s__('DuoChat|Type /help to learn more'),
    'WebAgenticDuoChat.chatSubmitLabel': s__('DuoChat|Send chat message.'),
    'WebDuoChat.chatBackToChatToolTip': s__('DuoChat|Back to chat'),
    'WebDuoChat.chatCancelLabel': __('Cancel'),
    'WebDuoChat.chatDefaultPredefinedPromptsChangePassword': s__(
      'DuoChat|How do I change my password in GitLab?',
    ),
    'WebDuoChat.chatDefaultPredefinedPromptsCloneRepository': s__(
      'DuoChat|How do I clone a repository?',
    ),
    'WebDuoChat.chatDefaultPredefinedPromptsCreateTemplate': s__(
      'DuoChat|How do I create a template?',
    ),
    'WebDuoChat.chatDefaultPredefinedPromptsForkProject': s__('DuoChat|How do I fork a project?'),
    'WebDuoChat.chatDefaultTitle': s__('DuoChat|GitLab Duo Chat'),
    'WebDuoChat.chatDisclaimer': s__('DuoChat|Responses may be inaccurate. Verify before use.'),
    'WebDuoChat.chatDropdownMoreOptions': s__('DuoChat|More options'),
    'WebDuoChat.chatEmptyStateDescription': s__('DuoChat|How can I help you today?'),
    'WebDuoChat.chatEmptyStateTitle': s__(
      'DuoChat|I am GitLab Duo Chat, your personal AI-powered assistant.',
    ),
    'WebDuoChat.chatHistoryTitle': s__('DuoChat|Chat history'),
    'WebDuoChat.chatModelPlaceholder': s__('DuoChat|GitLab Duo Chat'),
    'WebDuoChat.chatPromptPlaceholderDefault': s__("DuoChat|Let's work through this together..."),
    'WebDuoChat.chatPromptPlaceholderWithCommands': s__('DuoChat|Type /help to learn more'),
    'WebDuoChat.chatSubmitLabel': s__('DuoChat|Send chat message.'),
    'WebDuoChat.chatTitle': s__('DuoChat|GitLab Duo Chat'),
    'WebDuoChat.closeChatHeaderLabel': s__('DuoChat|Close chat'),
    'WebDuoChat.copySessionIdFailedToast': s__('DuoChat|Could not copy session ID'),
    'WebDuoChat.copySessionIdSuccessToast': s__('DuoChat|Session ID copied to clipboard'),
    'WebDuoChat.copySessionIdTooltip': s__('DuoChat|Copy Chat Session ID (%{id})'),
    Yes: __('Yes'),
  },
});
